import Marionette from "../../../shared/marionette-mustache";
import { AuthorizationModel } from "../../../authentication/models/authorization-model";
import { AppSettings } from "../../../app-settings";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { PublisherModel } from "../../../desktop/models/publisher";

const template = require<string>("../../../desktop/views/partials/publisher-link-list.html");

@backboneViewProperties({
    tagName: "li",
    className: "publisher-block",
    template
})
export class PublisherLinkListView extends Marionette.ItemView<PublisherModel> {
    constructor(options?: Backbone.ViewOptions<PublisherModel>) {
        super(options);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click a"] = (e) => this.logClick(e);
        return events;
    }

    public initialize() {
        if (!this.model.DisplayLink) {
            this.$el.addClass("deactivated");
        }
    }

    private logClick(e: Event) {
        try {
            const target = $(e.target);
            $.ajax({
                url: AppSettings.ApiUrlPrefix + "logging/Log",
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                method: "POST",
                cache: false,
                data: {
                    name: target.parents("a").find(".citation").html() + " at " + target.parents(".full-text-source-heading").find(".publisher-logo").attr("title"),
                    url: target.parents("a").attr("href"),
                    siteId: target.parents().data("site-id")
                }
            });
        } catch (e) {
            dev.log("Error logging multilink click: " + e);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/publisher-link-list.ts